import { render, staticRenderFns } from "./SelectCustomSimple.vue?vue&type=template&id=166699d2&scoped=true"
import script from "./SelectCustomSimple.vue?vue&type=script&lang=js"
export * from "./SelectCustomSimple.vue?vue&type=script&lang=js"
import style0 from "./SelectCustomSimple.vue?vue&type=style&index=0&id=166699d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166699d2",
  null
  
)

export default component.exports